import React from "react";
import "./HousekeepingServices.css";

// 👉 Replace with your own small icon
import ServiceIcon from "../../Image/HouseKeeping/rightthick.png";

const services = [
"Production floor cleaning",
  "Machine area degreasing",
  "Heavy-duty floor scrubbing",
  "Warehouse & dock cleaning",
  "Loading bay maintenance",
  "Industrial ceiling cleaning",
  "Equipment & machinery cleaning",
  "Oil & grease removal",
  "Dust & debris management",
  "Waste segregation support",
  "Safety area maintenance",
  "Storage area cleaning"
];

const steps = [
  {
    number: "01",
    title: "Safety Assessment",
    desc: "Evaluate industrial site, identify hazards, and plan safe cleaning approach.",
  },
  {
    number: "02",
    title: "Safety Assessment",
    desc: "Align cleaning activities with production schedules to minimize operational impact.",
  },
  {
    number: "03",
    title: "Specialized Cleaning",
    desc: "Execute heavy-duty cleaning using industrial equipment and specialized solutions.",
  },
  {
    number: "04",
    title: "Quality & Safety Check",
    desc: "Verify cleaning standards and ensure all safety protocols were followed.",
  },
];

const IndustrialServices = () => {
  return (
    <>
      {/* ---------------- SERVICES SECTION ---------------- */}
      <section className="hk-services-section">
        <h2 className="hk-section-title">Our Service Includes</h2>

        <div className="hk-services-grid">
          {services.map((item, index) => (
            <div key={index} className="hk-service-card">
              <img src={ServiceIcon} alt="service" className="hk-service-img" />
              <span>{item}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ---------------- PROCESS SECTION ---------------- */}
      <section className="hk-process-section">
        <div className="hk-process-tag">Our Process</div>
        <h2 className="hk-section-title">Industrial & Warehouse Cleaning Process</h2>

        <div className="hk-process-grid">
          {steps.map((step, index) => (
            <div key={index} className="hk-process-card">
              <div className="hk-process-number">{step.number}</div>
              <h4>{step.title}</h4>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default IndustrialServices;
